import {useMutation} from 'react-query';
import postPaymentStorePlans from '.';
import {toast} from 'react-toastify';
import {AxiosError} from 'axios';

const usePaymentStorePlans = () => {
  const {isLoading, mutate, isSuccess} = useMutation({
    mutationFn: (payload: IPaymentStorePlansPayload) => {
      return postPaymentStorePlans(payload);
    },
    onSuccess: data => {
      window.location.replace(data.ipg_url);
    },
    onError: (error: AxiosError<IAxiosErr>) => {
      error?.response?.status === 400 &&
        toast.error(
          error?.response?.data?.message ||
            'مشکلی پیش آمده ،لطفا در زمان دیگری مراجعه فرمایید',
        );
    },
  });

  return {isLoading, mutate, isSuccess};
};

export default usePaymentStorePlans;
